<template>
  <div class="browser-preview">
    <div class="browser-header">
      <div class="browser-controls">
        <span class="control-btn close"></span>
        <span class="control-btn minimize"></span>
        <span class="control-btn maximize"></span>
      </div>

      <div class="address-bar">
        <input
          v-model="url"
          @keyup.enter="loadUrl"
          placeholder="请输入网页地址，按回车访问"
          type="text"
        />
        <button @click="copyUrl" class="action-btn copy-btn" :disabled="!url">
          {{ copySuccess ? "已复制" : "复制链接" }}
        </button>
      </div>
    </div>

    <div class="browser-body" ref="browserBody">
      <div v-if="loading" class="loading-wrapper">
        <div class="spinner"></div>
        <div>加载中...</div>
      </div>

      <iframe
        :src="currentUrl"
        class="web-iframe"
        @load="onIframeLoaded"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      ></iframe>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "BrowserPreview",
  props: {
    src: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: "",
      currentUrl: "",
      loading: false,
      exportLoading: false,
      copySuccess: false,
      debounceTimer: null
    };
  },
  watch: {
    src: {
      immediate: true,
      handler(val) {
        if (val) {
          this.url = val;
          this.loadUrl();
        }
      }
    }
  },
  methods: {
    onInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.loadUrl();
      }, 200);
    },

    loadUrl() {
      if (!this.url) return;
      this.loading = true;
      let targetUrl = this.url.trim();
      if (!/^https?:\/\//i.test(targetUrl)) {
        targetUrl = "https://" + targetUrl;
      }
      this.currentUrl = targetUrl;
    },

    onIframeLoaded() {
      this.loading = false;
    },

    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.currentUrl);
        this.copySuccess = true;
        setTimeout(() => (this.copySuccess = false), 1500);
      } catch (e) {
        alert("复制失败");
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  }
};
</script>

<style lang="scss" scoped>
.browser-preview {
  width: 100%;
  height: 800px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: var(--card-bg);
  display: flex;
  flex-direction: column;
}

.browser-header {
  padding: 10px 12px;
  background: var(--card-bg);
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--table-border);
}

.browser-controls {
  display: flex;
  gap: 8px;
}
.control-btn {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  &.close {
    background: #ff5f57;
  }
  &.minimize {
    background: #ffbd2e;
  }
  &.maximize {
    background: #28ca42;
  }
}

.address-bar {
  flex: 1;
  display: flex;
  gap: 8px;
  input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid var(--input-border);
    border-radius: 6px;
    outline: none;
  }
}

.action-btn {
  padding: 0 12px;
  border: none;
  border-radius: 6px;
  color: #fff;
  &:disabled {
    opacity: 0.6;
  }
}
.copy-btn {
  background: #67c23a;
}
.export-btn {
  background: var(--accent);
}

.browser-body {
  flex: 1;
  position: relative;
  background: var(--card-bg);
}

.loading-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-sub);
  z-index: 9;
  background: var(--card-bg);
}
.spinner {
  width: 28px;
  height: 28px;
  border: 3px solid var(--table-border);
  border-top: 3px solid var(--accent);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin-bottom: 8px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.web-iframe {
  width: 100%;
  height: 100%;
  border: none;
  z-index: 1;
}
</style>
